<template>
    <div class="inner-page" ref="page">
        <div class="heads">
            <img src="../../assets/redHeadBack.jpg">
            <h1>红色经典</h1>
        </div>
        <div class="mainBox">
            <a href="http://wap.china1904.com/wx/redSong?iab=ba00f82b81d6714c0181d6837a2c1c06&icd=ba00f82b81d6714c0181d68562df1ef2">
                <img src="../../assets/hsjdOne.jpg">
            </a>
            <a href="http://wap.china1904.com/wx/redSong?iab=ba00f82b81d6714c0181d6856f551f09&icd=ba00f82b81d6714c0181d688263e2338">
                <img src="../../assets/hsjdTwo.jpg">
            </a>
            <a href="http://wap.china1904.com/wx/redSong?iab=ba00f82b81d6714c0181d6882fb4234a&icd=ba00f82b81d6714c0181d688fc2a24b3">
                <img src="../../assets/hsjdThree.jpg">
            </a>
            <a href="http://wap.china1904.com/wx/redSong?iab=ba00f82b81d6714c0181d68906d424c9&icd=ba00f82b81d6714c0181d68a442426d2">
                <img src="../../assets/hsjdFour.jpg">
            </a>
            <a href="http://wap.china1904.com/wx/redSong?iab=ba00f82b81d6714c0181d68a4c1926e1&icd=ba00f82b81d6714c0181d68abfe227ac">
                <img src="../../assets/hsjdFive.jpg">
            </a>
            <a href="http://wap.china1904.com/wx/redSong?iab=ba00f82b81d6714c0181d68acad927bd&icd=ba00f82b81d6714c0181d68b599428af">
                <img src="../../assets/hsjdSix.jpg">
            </a>
        </div>
        <div class="foots">
            <img src="../../assets/redBotBack.jpg">
        </div>
    </div>
</template>

<script>
    export default {
        name: "hsjd"
    }
</script>

<style scoped lang="scss">

    .inner-page{
        background-color: #EDE5D5;
        .heads{
            width: 100%;
            height: 100%;
            position: relative;
            img{
                width: 100%;
            }
            h1{
                position: absolute;
                left: 50%;
                top: 35%;
                transform: translate(-50%,-50%);
                font-size: 24px;
                letter-spacing: 5px;
            }
        }
        .mainBox{
            width: auto;
            height: 100%;
            overflow-y: hidden;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            padding:  20px 10px;
            margin-bottom: 64px;
            a{
                display: block;
                overflow-y: hidden;
                width: 165px;
                padding: 0 6px;

            }
            img{
                width:100%;
                float: left;
                margin-bottom: 20px;
            }
        }
        .foots{
            position: fixed;
            bottom: -3px;
            left: 0;
        }

    }

</style>
